<template>
  <div>
    <bu-la-header></bu-la-header>
    <router-view />
    <footer>
      <a
        href="https://www.bps-pfadfinder.de/footer-navigation/impressum/"
        target="blank"
        ><h4>Impressum</h4></a
      >
      <a href="https://www.bps-pfadfinder.de" target="blank">
        <svg
          width="1.5rem"
          height="1.5rem"
          viewBox="0 0 9840 9840"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="
            fill-rule: evenodd;
            clip-rule: evenodd;
            stroke-linejoin: round;
            stroke-miterlimit: 2;
          "
        >
          <path
            id="path54"
            d="M0,4924.92c0,2708.14 2206.46,4914.69 4924.84,4914.69c2708.22,-0 4914.68,-2206.55 4914.68,-4914.69c0,-2718.46 -2206.46,-4924.92 -4914.68,-4924.92c-2718.38,0 -4924.84,2206.46 -4924.84,4924.92Zm107.433,0c0,-2657.02 2160.47,-4817.4 4817.4,-4817.4c2646.78,0 4807.25,2160.38 4807.25,4817.4c-0,2646.7 -2160.47,4807.16 -4807.25,4807.16c-2656.94,-0 -4817.4,-2160.47 -4817.4,-4807.16m4817.4,4617.73c2549.5,-0 4617.81,-2068.22 4617.81,-4617.73c-0,-2554.62 -2068.31,-4627.96 -4617.81,-4627.96c-2559.66,0 -4627.96,2073.34 -4627.96,4627.96c-0,2549.5 2068.31,4617.73 4627.96,4617.73m-1720.06,-5841.32l-491.52,-0l-0,839.594l1786.71,0l-0,1617.75c-184.32,128 -465.834,225.28 -675.754,97.28c20.48,-481.193 -148.48,-1023.91 -583.594,-1203.03c-235.52,-102.401 -609.28,-128.001 -814.081,86.953c-117.673,153.6 -127.913,404.48 -51.113,522.24c10.153,20.48 25.6,35.84 46.08,61.44c-327.68,158.721 -788.481,143.361 -1090.47,-51.2c-455.681,-286.72 -691.114,-911.274 -593.834,-1387.35c97.193,-471.041 332.714,-824.235 870.314,-1023.92c537.514,-199.68 1238.87,-56.32 1597.27,440.234m1141.59,3563.18c-20.48,271.361 -117.76,496.554 -271.274,716.714c-240.64,343.041 -588.8,583.594 -998.314,517.034c-332.8,-56.32 -578.561,-255.913 -670.634,-506.794c-71.68,-189.44 -56.407,-424.96 56.233,-593.833c158.721,179.113 435.201,255.913 660.481,199.68c204.8,-46.08 327.594,-122.88 465.834,-353.281c189.44,71.681 481.28,81.921 757.674,20.48m993.194,-5273.08l0,1709.91l1080.23,-0c61.44,-102.4 133.034,-174.08 209.834,-261.034c-271.274,-982.954 -911.274,-1817.43 -1704.79,-2401.02c-803.668,583.594 -1438.55,1418.07 -1709.82,2401.02c71.68,86.954 143.274,158.634 204.714,261.034l1080.23,-0l-0,-1709.91l839.594,-0m1300.31,1709.91l491.52,-0l0,839.594l-1791.83,0l0,1617.75c184.32,128 465.834,225.28 680.874,97.28c-20.48,-481.193 143.36,-1023.91 578.474,-1203.03c235.52,-102.401 609.28,-128.001 813.994,86.953c117.76,153.6 133.12,404.48 51.2,522.24c-10.24,20.48 -25.6,35.84 -40.96,61.44c322.56,158.721 783.274,143.361 1085.35,-51.2c460.714,-286.72 696.234,-911.274 593.834,-1387.35c-97.28,-471.041 -327.594,-824.235 -865.194,-1023.92c-537.514,-199.68 -1243.99,-56.32 -1597.27,440.234m-1715.03,3168.94c184.32,0 327.68,97.28 491.52,174.08c153.6,71.68 511.914,153.6 834.474,35.84c61.44,-133.12 40.96,-368.553 -30.72,-501.673c-51.2,-61.44 -81.92,-122.881 -158.72,-163.841c-194.56,76.8 -266.24,92.16 -501.674,35.84c-122.88,-30.72 -378.88,-220.16 -634.88,-220.16c-266.154,0 -517.034,189.44 -645.034,220.16c-230.4,56.32 -307.114,40.96 -501.674,-35.84c-76.8,40.96 -102.4,102.401 -158.72,163.841c-71.68,133.12 -87.04,368.553 -25.6,501.673c322.56,117.76 675.754,35.84 834.474,-35.84c158.72,-76.8 302.08,-174.08 496.554,-174.08m-0,1991.51c307.2,-122.881 619.52,-337.921 752.554,-685.994c-240.554,-373.761 -296.874,-517.121 -348.074,-988.075c-128,-56.32 -266.24,-158.72 -404.48,-158.72c-148.394,0 -281.514,102.4 -409.514,158.72c-51.2,470.954 -112.64,614.314 -353.28,988.075c138.24,348.073 445.44,563.113 762.794,685.994m568.32,-1597.27c20.48,271.361 122.88,496.554 276.394,716.714c240.64,343.041 588.8,583.594 993.194,517.034c332.8,-56.32 578.474,-255.913 675.754,-506.794c66.56,-189.44 51.2,-424.96 -61.44,-593.833c-158.72,179.113 -429.994,255.913 -660.394,199.68c-204.8,-46.08 -327.594,-122.88 -460.714,-353.281c-194.56,71.681 -486.4,81.921 -762.794,20.48"
            style="fill: #2056ae"
          />
        </svg>
      </a>
      <a href="https://www.gjw.de" target="blank">
        <svg
          width="1.5rem"
          height="1.5rem"
          viewBox="0 0 430 444"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="
            fill-rule: evenodd;
            clip-rule: evenodd;
            stroke-linejoin: round;
            stroke-miterlimit: 2;
          "
        >
          <path
            d="M181.554,242.92l-133.512,0l-0,38.334l102.162,-0c6.704,0.023 12.205,5.55 12.196,12.254l0,50.717c-0.054,6.462 -5.386,11.75 -11.85,11.75c-0.033,0 -0.067,-0 -0.1,-0l-54.95,-0c-6.51,0.23 -12.056,-4.937 -12.287,-11.446l-0,-0.275l0.091,-25.354l-35.262,-0l-0,56.42c-0,10.467 8.612,19.08 19.079,19.08l114.654,-0c10.34,-0.179 18.749,-8.734 18.75,-19.075l0.067,-113.905c-0.387,-10.201 -8.826,-18.411 -19.034,-18.516"
            style="fill: #7fae13; fill-rule: nonzero"
          />
          <path
            d="M326.792,317.529l-25.221,-0c-6.696,0.251 -12.02,5.923 -11.85,12.621l-0,25.833l-26.717,-0c-6.529,-0.205 -11.812,-5.581 -11.904,-12.113l-0.037,-101.012l-38.305,-0l0,132.421c0.055,10.476 8.69,19.067 19.167,19.067c0.035,-0 0.069,-0 0.104,-0.001l113.854,0c10.091,-0.008 18.528,-8 19.084,-18.075l-0,-133.412l-38.175,-0l-0,74.671Z"
            style="fill: #7fae13; fill-rule: nonzero"
          />
          <path
            d="M66.875,228.15l114.5,0.187c10.519,-0.014 19.167,-8.673 19.167,-19.192c-0,-0.011 -0,-0.022 -0,-0.033l-0,-56.721l-63.054,0.038l-0,23.221l24.941,-0l0,4.425c-0.075,5.484 -4.649,9.936 -10.133,9.862l-54.079,0c-6.714,-0.043 -12.219,-5.566 -12.242,-12.279l-0,-50.621c0.021,-6.737 5.579,-12.266 12.317,-12.25l102.245,0l0,-38.508l-133.65,-0c-10.336,0.009 -18.837,8.517 -18.837,18.854c-0,0.005 -0,0.011 0,0.017l0,113.954c-0.143,10.313 8.225,18.917 18.537,19.062l0.288,0"
            style="fill: #7fae13; fill-rule: nonzero"
          />
          <path
            d="M389.483,380.295c0.001,0.052 0.001,0.103 0.001,0.155c-0,21.361 -17.531,38.959 -38.892,39.041l-287.625,0c-21.422,-0.082 -38.984,-17.773 -38.909,-39.196l0,-289.791c-0.078,-21.424 17.485,-39.118 38.909,-39.2l215.075,-0c-15.219,40.498 5.579,86.346 46.075,101.571c8.709,3.272 17.929,4.977 27.233,5.037c13.367,0.016 26.513,-3.429 38.154,-10l-0.021,232.383Zm-52.354,-357.5l0,28.417l-23.75,0.058l-0.241,0l-0,24.342l23.995,0l0,59.475c-25.571,-6.535 -43.601,-29.753 -43.601,-56.146c-0,-4.841 0.606,-9.663 1.806,-14.354c4.173,-16.338 15.278,-30.066 30.383,-37.562c3.641,-1.806 7.466,-3.215 11.408,-4.205m71.421,56.134c0.013,16.375 -6.919,32.01 -19.063,42.996c-6.914,6.294 -15.271,10.793 -24.333,13.1l0,-59.4l24.167,-0l-0,-24.342l-24.196,-0l0,-28.438c4.549,1.137 8.939,2.833 13.071,5.05c18.692,10.137 30.361,29.779 30.325,51.042m21.129,0c0.437,-42.877 -34.485,-78.519 -77.362,-78.958c-22.943,-0.225 -44.86,9.659 -59.88,27.004l-233.283,-0c-32.471,0.435 -58.983,27.189 -59.125,59.662l0,299.042c0,29.667 27.696,58.063 59.125,58.063l294.363,-0c32.9,-0.76 59.699,-27.713 60.27,-60.617l-0.158,-256.413c10.44,-13.731 16.089,-30.517 16.075,-47.766"
            style="fill: #7fae13; fill-rule: nonzero"
          />
        </svg>
      </a>
      <a
        href="https://www.instagram.com/bula.2023/"
        title="Folge uns auf Instagram"
        target="blank"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="1.5rem"
          height="1.5rem"
          viewBox="0 0 100 100"
          version="1.1"
        >
          <title>Folge uns auf Instagram</title>
          <defs>
            <linearGradient
              x1="-580.922776%"
              y1="-579.360825%"
              x2="175.364279%"
              y2="175.054194%"
              id="linearGradient-1"
            >
              <stop stop-color="#FFD521" offset="0%" />
              <stop stop-color="#FFD521" offset="5%" />
              <stop stop-color="#F50000" offset="50.1119%" />
              <stop stop-color="#B900B4" offset="95%" />
              <stop stop-color="#B900B4" offset="95.0079%" />
              <stop stop-color="#B900B4" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="0.901986149%"
              y1="0.909399226%"
              x2="91.7455387%"
              y2="91.7529518%"
              id="linearGradient-2"
            >
              <stop stop-color="#FFD521" offset="0%" />
              <stop stop-color="#FFD521" offset="5%" />
              <stop stop-color="#F50000" offset="50.1119%" />
              <stop stop-color="#B900B4" offset="95%" />
              <stop stop-color="#B900B4" offset="95.0079%" />
              <stop stop-color="#B900B4" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="-45.53096%"
              y1="-45.6022794%"
              x2="131.224866%"
              y2="131.281314%"
              id="linearGradient-3"
            >
              <stop stop-color="#FFD521" offset="0%" />
              <stop stop-color="#FFD521" offset="5%" />
              <stop stop-color="#F50000" offset="50.1119%" />
              <stop stop-color="#B900B4" offset="95%" />
              <stop stop-color="#B900B4" offset="95.0079%" />
              <stop stop-color="#B900B4" offset="100%" />
            </linearGradient>
          </defs>
          <g
            id="Playground"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="Instagram-Glyph-Color-Logo.wine" fill-rule="nonzero">
              <path
                d="M82.6102641,23.2762102 C82.6102641,26.5963579 79.9194134,29.2772109 76.6116703,29.2772109 C73.303742,29.2772109 70.6104845,26.5963579 70.6104845,23.2762102 C70.6104845,19.968282 73.303742,17.287429 76.6116703,17.287429 C79.9194134,17.287429 82.6102641,19.968282 82.6102641,23.2762102"
                id="Path"
                fill="url(#linearGradient-1)"
                transform="translate(76.610374, 23.282320) scale(-1, 1) rotate(-180.000000) translate(-76.610374, -23.282320) "
              />
              <path
                d="M90.6033903,29.7683921 C90.3812202,24.8978671 89.5665964,22.2516356 88.8902734,20.4940847 C87.9817827,18.163705 86.8981478,16.497429 85.1405969,14.7496905 C83.4026709,13.0019521 81.7363949,11.9207241 79.4060152,11.022231 C77.6484643,10.3359104 74.9922351,9.51887969 70.1218953,9.28671189 C64.856463,9.05472924 63.2962732,9.00529638 49.9438477,9.00529638 C36.6038267,9.00529638 35.0312324,9.05472924 29.7658001,9.28671189 C24.8954603,9.51887969 22.2516356,10.3359104 20.4938995,11.022231 C18.1513005,11.9207241 16.497429,13.0019521 14.7496905,14.7496905 C12.9895476,16.497429 11.9059127,18.163705 11.0098265,20.4940847 C10.3333184,22.2516356 9.50647519,24.8978671 9.29652441,29.7683921 C9.0399179,35.0338244 8.99289188,36.6186381 8.99289188,49.9438477 C8.99289188,63.2962732 9.0399179,64.8688675 9.29652441,70.1342998 C9.50647519,75.0046396 10.3333184,77.6484643 11.0098265,79.4210117 C11.9059127,81.7487994 12.9895476,83.4052629 14.7496905,85.1530014 C16.497429,86.8981478 18.1513005,87.9819678 20.4938995,88.8902734 C22.2516356,89.5790009 24.8954603,90.3838122 29.7658001,90.6157948 C35.0312324,90.8479626 36.6038267,90.907208 49.9438477,90.907208 C63.2962732,90.907208 64.856463,90.8479626 70.1218953,90.6157948 C74.9922351,90.3838122 77.6484643,89.5790009 79.4060152,88.8902734 C81.7363949,87.9819678 83.4026709,86.8981478 85.1405969,85.1530014 C86.8981478,83.4052629 87.9817827,81.7487994 88.8902734,79.4210117 C89.5665964,77.6484643 90.3812202,75.0046396 90.6033903,70.1342998 C90.8477775,64.8688675 90.9070229,63.2962732 90.9070229,49.9438477 C90.9070229,36.6186381 90.8477775,35.0338244 90.6033903,29.7683921 Z M99.5964674,70.5440186 C99.3520802,75.8662895 98.5126474,79.5024741 97.2660877,82.6695095 C95.9973111,85.9552207 94.2964135,88.7397531 91.5118811,91.5242856 C88.7397531,94.2964135 85.9552207,95.9973111 82.6695095,97.2808991 C79.4900696,98.5152394 75.8661043,99.3644847 70.5414266,99.5964674 C65.2167489,99.853259 63.5160365,99.9000999 49.9438477,99.9000999 C36.3840634,99.9000999 34.6709465,99.853259 29.3462688,99.5964674 C24.0338104,99.3644847 20.4124371,98.5152394 17.2181859,97.2808991 C13.9448792,95.9973111 11.1603468,94.2964135 8.38821882,91.5242856 C5.60368638,88.7397531 3.90278881,85.9552207 2.62160766,82.6695095 C1.38726739,79.5024741 0.548019681,75.8662895 0.291228027,70.5440186 C0.0592453709,65.2193409 0,63.5160365 0,49.9438477 C0,36.3840634 0.0592453709,34.683351 0.291228027,29.3586733 C0.548019681,24.0462149 1.38726739,20.4126223 2.62160766,17.2305904 C3.90278881,13.9572837 5.60368638,11.1603468 8.38821882,8.38821882 C11.1603468,5.61609088 13.9448792,3.90278881 17.2181859,2.62160766 C20.4124371,1.38745253 24.0338104,0.548019681 29.3462688,0.303632526 C34.6709465,0.0592453709 36.3840634,0 49.9438477,0 C63.5160365,0 65.2167489,0.0592453709 70.5414266,0.303632526 C75.8661043,0.548019681 79.4900696,1.38745253 82.6695095,2.62160766 C85.9552207,3.90278881 88.7397531,5.61609088 91.5118811,8.38821882 C94.2964135,11.1603468 95.9973111,13.9572837 97.2660877,17.2305904 C98.5126474,20.4126223 99.3520802,24.0462149 99.5964674,29.3586733 C99.8408545,34.683351 99.9000999,36.3840634 99.9000999,49.9438477 C99.9000999,63.5160365 99.8408545,65.2193409 99.5964674,70.5440186 Z"
                id="Shape"
                fill="url(#linearGradient-2)"
                transform="translate(49.950050, 49.950050) scale(-1, 1) rotate(-180.000000) translate(-49.950050, -49.950050) "
              />
              <path
                d="M49.9438477,33.2958985 C40.7534095,33.2958985 33.2958985,40.7411902 33.2958985,49.9316283 C33.2958985,59.1368779 40.7534095,66.5917969 49.9438477,66.5917969 C59.1368779,66.5917969 66.6042014,59.1368779 66.6042014,49.9316283 C66.6042014,40.7411902 59.1368779,33.2958985 49.9438477,33.2958985 Z M49.9438477,75.5970933 C35.7767984,75.5970933 24.3030066,64.0986777 24.3030066,49.9316283 C24.3030066,35.7767984 35.7767984,24.2906021 49.9438477,24.2906021 C64.110897,24.2906021 75.5970933,35.7767984 75.5970933,49.9316283 C75.5970933,64.0986777 64.110897,75.5970933 49.9438477,75.5970933 Z"
                id="Shape"
                fill="url(#linearGradient-3)"
                transform="translate(49.950050, 49.943848) scale(-1, 1) rotate(-180.000000) translate(-49.950050, -49.943848) "
              />
            </g>
          </g>
        </svg>
      </a>
      <a
        href="https://www.bps-pfadfinder.de/footer-navigation/datenschutz/"
        target="blank"
        ><h4>Datenschutz</h4></a
      >
    </footer>
  </div>
</template>

<script>
import mixin from "@/mixin.js";
import BuLaHeader from "./components/buLaHeader.vue";

export default {
  components: { BuLaHeader },
  mixins: [mixin],
  computed: {},
  data() {
    return {};
  },
};
</script>

<style lang="less">
@import "~@/less/index.less";
@import "~@/less/main.less";
footer {
  display: flex;
  justify-content: space-around;
  path {
    fill: black !important;
  }
}
</style>
